import store from '../store';
import {
    fetchJobs as fetchJobsRedux,
    createJob as createJobRedux,
    loadResult as loadResultRedux,
    removeJob as removeJobRedux,
} from './thunks';
import {
    updateLocalJobState as updateLocalJobStateRedux,
    updateDisplayedCompoundJobs as updateDisplayedCompoundJobsRedux,
    setJobState as setJobStateRedux,
} from '.';

export function fetchJobs() {
    return store.dispatch(fetchJobsRedux());
}

export function getJobState() {
    return store.getState().jobs;
}

export function createJob(jobType, data, stash) {
    return store.dispatch(createJobRedux(jobType, data, stash));
}

export function loadResult(jobid, options) {
    return store.dispatch(loadResultRedux(jobid, options));
}

export function removeJob(jobid) {
    return store.dispatch(removeJobRedux(jobid));
}

export function updateLocalJobState(jobid, data) {
    return store.dispatch(updateLocalJobStateRedux({ jobid, ...data }));
}

export function updateDisplayedCompoundJobs(data) {
    return store.dispatch(updateDisplayedCompoundJobsRedux(data));
}

export function setJobState(state) {
    return store.dispatch(setJobStateRedux(state));
}
